import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import store from './store'
import MetaInfo from 'vue-meta-info'
import less from 'less'
import http from './api/http.js'
import qs from 'qs'
import router from './router'
import axios from 'axios'
const VueScrollTo = require('vue-scrollto')
Vue.use(less)
Vue.use(MetaInfo)
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.prototype.axios = axios;
Vue.prototype.http = http;
Vue.prototype.qs = qs;
Vue.use(VueScrollTo, {
	container: 'body', // 滚动元素
	duration: 500, // 动画时长
	easing: 'ease', // 动画曲线
	offset: 0, // 滚动终点距离父元素顶部距离
	force: true, // 强制立即执行，即便元素是可见的
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false, // x 轴禁止滚动
	y: true
})
const mixin = {
	filters: {
		keepOne(val) {
			return Number(val.toString().match(/^\d+(?:\.\d{0,1})?/));
		},
		handlePay(aa, bb) {
			var textSalary = ''
			if ((aa == '' && bb == '')||(aa == 0 && bb == 0)) {
				textSalary = '面议'
			} else if (aa != '' && bb == '') {
				textSalary = aa + '以上'
			} else if (aa == '' && bb != '') {
				textSalary = bb + '以下'
			} else if (aa != '' && bb != '') {
				textSalary = aa + '-' + bb
			}
			return textSalary
		}
	},
	methods: {
		handelHttps(str) {
			if (!str) {
				return ''
			}
			if (str.startsWith("https://")) {
				return str
			} else if (str.startsWith("http://")) {
				return str.replace("http://", "https://")
			} else {
				return 'https://' + str
			}
		}
	}
}
Vue.mixin(mixin)

new Vue({
	store,
	router,
	render: h => h(App),
	mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
